module KendoWidgets
{
	export class SlideShowOptions
	{
		dataSource?: SlideShowImage[];
		width?: number;
		height?: number;
	}

	export class SlideShow extends kendo.ui.Widget implements KendoWidget
	{
		private _slideShowDataSource: SlideShowImage[];
		private _slideShowWindow: KendoWidgets.Window;
		private _actualIndex: number;
		private _image: KendoWidgets.Image;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.SlideShow; }

		constructor(element: Element, options?: KendoWidgets.SlideShowOptions)
		{
			if (options == null)
				options = new KendoWidgets.SlideShowOptions();

			if (options.dataSource == null) options.dataSource = [];
			if (options.width == null) options.width = 1100;
			if (options.height == null) options.height = 600;

			super(element, options);
			let that = this;
			this._slideShowDataSource = options.dataSource;

			this._slideShowWindow = <KendoWidgets.Window>$("<div class='k-slideshow' id='" + element.id + "'></div>").kendoWindow(<KendoWidgets.WindowOptions>
				{
					height: options!.height,
					width: options!.width,
					showCancelButton: false,
					showOkButton: false,
					title: false,
					draggable: false
				}).data("kendoWindow");

			//#region Go Back
			$("<div class='slideShow_NavigationButtonDiv' style='float: left;'><button id='" + element.id + "GoBack' class='slideShow_NavigationButton'></button></div>").appendTo(this._slideShowWindow.element);
			$("#" + element.id + "GoBack").kendoButton(
				{
					icon: IconClass.ArrowLeft,
					visible: false,
					click: (e) =>
					{
						if (this._actualIndex == 0)
							this.doWebApiCall(this._slideShowDataSource[this._slideShowDataSource.length - 1].fileId);
						else
							this.doWebApiCall(this._slideShowDataSource[this._actualIndex - 1].fileId);
					}
				});
			//#endregion

			//#region Image
			$("<img id='" + element.id + "Image'></img>").appendTo(this._slideShowWindow.element);
			this._image = $("#" + element.id + "Image").kendoImage(
				{
					overlayDescription: true,
					css: "max-width: 100%; max-height: 100%;",
					toolbarItems:
						[
							{ type: ImageToolbarTypeEnum.Custom, value: "close", icon: IconClass.Delete, click: (e) => this._slideShowWindow.close() },
							{ type: ImageToolbarTypeEnum.Download },
							{
								type: ImageToolbarTypeEnum.Custom, value: "exitFullScreen", icon: IconClass.ExitFullScreen, click: (e) =>
								{
									this._slideShowWindow.size(options!.width!, options!.height!);

									$("#customToolbarImage_imageGallery_sldSlideShowImage_fullScreen").show();
									$("#customToolbarImage_imageGallery_sldSlideShowImage_exitFullScreen").hide();
								}
							},
							{
								type: ImageToolbarTypeEnum.Custom, value: "fullScreen", icon: IconClass.FullScreen, click: (e) =>
								{
									this._slideShowWindow.size(document.body.clientWidth - 40, document.body.clientHeight - 20);

									$("#customToolbarImage_imageGallery_sldSlideShowImage_fullScreen").hide();
									$("#customToolbarImage_imageGallery_sldSlideShowImage_exitFullScreen").show();
								}
							}
						]
				}).data("kendoImage");
			//#endregion

			//#region Hover
			$(this._slideShowWindow.element).hover((e) =>
			{
				$("#" + element.id + "GoBack").show();
				$("#" + element.id + "GoForward").show();
			});

			$(this._slideShowWindow.element).mouseleave((e) =>
			{
				$("#" + element.id + "GoBack").hide();
				$("#" + element.id + "GoForward").hide();
			});
			//#endregion

			//#region Go Forward
			$("<div class='slideShow_NavigationButtonDiv' style='float: right;'><button id='" + element.id + "GoForward' class='slideShow_NavigationButton'></button></div>").appendTo(this._slideShowWindow.element);
			$("#" + element.id + "GoForward").kendoButton(
				{
					icon: IconClass.ArrowRight,
					visible: false,
					click: (e) =>
					{
						if (this._actualIndex == this._slideShowDataSource.length - 1)
							this.doWebApiCall(this._slideShowDataSource[0].fileId);
						else
							this.doWebApiCall(this._slideShowDataSource[this._actualIndex + 1].fileId);
					}
				});
			//#endregion
			$(this._slideShowWindow.element).keydown((e) =>
			{
				if (e.keyCode == 39)
					$("#" + element.id + "GoForward").data("kendoButton").trigger("click");
				else if (e.keyCode == 37)
					$("#" + element.id + "GoBack").data("kendoButton").trigger("click");
			});
		}

		open(fileId: number, dataSource?: SlideShowImage[])
		{
			this._image.clear();
			this._slideShowWindow.open();
			if (dataSource != null)
				this._slideShowDataSource = dataSource;

			this.doWebApiCall(fileId);
		}

		private doWebApiCall(fileId: number)
		{
			let image = this._slideShowDataSource.filter(k => k.fileId == fileId)[0];
			if (image == null)
				return;

			this._actualIndex = this._slideShowDataSource.findIndex(k => k.fileId == fileId);

			let description = "<span class='slideShow_fileNameClass'>" + image.fileName + "</span>";
			description += "<span class='slideShow_fileDateClass'>" + image.uploadDate.toItalyShortString() + "</span>";
			if (image.description != null)
				description += "<br />" + image.description;

			this._image.overlayDescription(description);

			let that = this;
			let json: any = {};
			json.AuthKey = "fasd@fàadesrfi45334";
			json.id = fileId;

			let method = "/api/ImageGalleryWebApi/GetImageBytes";
			let jsonS = JSON.stringify(json);
			$.ajax({
				type: "POST",
				contentType: "application/json",
				data: jsonS,
				method: "POST",
				processData: false,
				dataType: "json",
				url: method,
				success: function (response: any, textStatus: string, jqXHR: JQueryXHR)
				{
					if (response != null && response.Success)
					{
						$("#customToolbarImage_imageGallery_sldSlideShowImage_fullScreen").show();
						$("#customToolbarImage_imageGallery_sldSlideShowImage_exitFullScreen").hide();

						if (response.base64Bytes != null && response.base64Bytes.length > 0)
							that._image.value(response.base64Bytes, ImageSourceTypeEnum.Base64Bytes, response.fileName, response.mimeType);
					}
				}
			});
		}
	}

	export class SlideShowImage
	{
		fileId: number;
		uploadDate: Date;
		fileName: string;
		description?: string;
	}

	SlideShow.fn = SlideShow.prototype;
	SlideShow.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	SlideShow.fn.options.name = "SlideShow";
	kendo.ui.plugin(SlideShow);
}

interface JQuery
{
	kendoSlideShow(options?: KendoWidgets.SlideShowOptions): JQuery;
	data(key: "kendoSlideShow"): KendoWidgets.SlideShow;
}